import { FormControlLabel, Switch } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { VoucherCustomerDetails_voucher_eligibleCustomers_edges } from "@saleor/discounts/types/VoucherCustomerDetails";
import { CustomerListProps } from "@saleor/discounts/views/VoucherDetails/utils";
import { FormChange } from "@saleor/hooks/useForm";
// import { VoucherTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
import { ListActions, ListProps } from "../../../types";
import { VoucherDetails_voucher } from "../../types/VoucherDetails";
import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";
export interface VoucherCustomersProps
  extends ListProps,
    CustomerListProps,
    ListActions {
  data: VoucherDetailsPageFormData;
  voucher: VoucherDetails_voucher;
  voucherCustomers: VoucherCustomerDetails_voucher_eligibleCustomers_edges[];
  onChange: FormChange;
  onCustomerAssign: () => void;
  onCustomerUnassign: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 300
    },
    colNameLabel: {
      // marginLeft: theme.spacing()
    },
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 300
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "VoucherCustomers" }
);

const numberOfColumnsVoucher = 5;

const VoucherCustomers: React.FC<VoucherCustomersProps> = props => {
  const {
    data,
    disabled,
    customerPageInfo,
    onRowClick,
    onPreviousCustomerPage,
    onChange,
    onCustomerAssign,
    onCustomerUnassign,
    onNextCustomerPage,
    isChecked,
    selected,
    toggle,
    toggleAll,
    toolbar,
    voucher,
    voucherCustomers
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  function showTable() {
    const customerData = maybe(() => voucherCustomers.map(edge => edge.node));

    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          {customerData && customerData.length > 0 && <col />}
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colPublished} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumnsVoucher}
          selected={selected}
          disabled={disabled}
          items={customerData}
          toggleAll={toggleAll}
          toolbar={toolbar}
        >
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Email" />
          </TableCell>
          <TableCell className={classes.colPublished}>
            <FormattedMessage defaultMessage="Mobile No." />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={numberOfColumnsVoucher}
              hasNextPage={
                customerPageInfo && !disabled
                  ? customerPageInfo.hasNextPage
                  : false
              }
              onNextPage={onNextCustomerPage}
              hasPreviousPage={
                customerPageInfo && !disabled
                  ? customerPageInfo.hasPreviousPage
                  : false
              }
              onPreviousPage={onPreviousCustomerPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {renderCollection(
            customerData,
            (customer, index) => {
              const isSelected = customer ? isChecked(customer.id) : false;
              return (
                <TableRow
                  hover={!!customer}
                  key={customer ? customer.id : "skeleton"}
                  onClick={customer && onRowClick(customer.id)}
                  className={classes.tableRow}
                  selected={isSelected}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      id={`customerCheckboxRow${index}`}
                      checked={isSelected}
                      disabled={disabled}
                      disableClickPropagation
                      onChange={() => toggle(customer.id)}
                    />
                  </TableCell>
                  <TableCell
                    className={classes.colName}
                    id={`customerNameRow${index}`}
                  >
                    {`${maybe<React.ReactNode>(
                      () => customer.firstName,
                      ""
                    )} ${maybe<React.ReactNode>(() => customer.lastName, "")}`}
                  </TableCell>
                  {/* <TableCellAvatar
                    className={classes.colName}
                    thumbnail={isImportImage(maybe(() => product.thumbnail.url))}
                  >
                    {maybe<React.ReactNode>(() => product.name, <Skeleton />)}
                  </TableCellAvatar> */}
                  <TableCell
                    className={classes.colType}
                    id={`customerEmailRow${index}`}
                  >
                    {maybe<React.ReactNode>(() => customer.email, <Skeleton />)}
                  </TableCell>
                  <TableCell
                    className={classes.colPublished}
                    id={`customerMobileNoRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => customer.contactNo,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colActions}>
                    <IconButton
                      id={`customerDeleteBtnRow${index}`}
                      disabled={!customer || disabled}
                      onClick={event => {
                        event.stopPropagation();
                        onCustomerUnassign(customer.id);
                      }}
                    >
                      <DeleteIcon color="primary" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            },
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumnsVoucher}>
                  <FormattedMessage defaultMessage="No Customer Assigned" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Eligible Customers",
          description: "section header"
        })}
        toolbar={
          voucher /* && voucher.type === VoucherTypeEnum.SPECIFIC_CUSTOMER*/ ? (
            <>
              <FormControlLabel
                control={
                  <Switch
                    id="specificCustomerToggle"
                    checked={data.isSpecificCustomer}
                    onChange={event =>
                      onChange({
                        target: {
                          name: "isSpecificCustomer",
                          value: event.target.checked
                        }
                      })
                    }
                    name="isSpecificCustomer"
                  />
                }
                label="Specific Customers"
              />
              {/* <Switch checked={data.isAppliedToAllCustomers}> Applied to all customers </Switch> */}
              <Button
                id="assignCustomersDialogBtn"
                disabled={disabled || !data.isSpecificCustomer}
                color="primary"
                className={
                  disabled || !data.isSpecificCustomer
                    ? classes.buttonDisabled
                    : null
                }
                onClick={onCustomerAssign}
              >
                <FormattedMessage
                  defaultMessage="Assign customers"
                  description="button"
                />
              </Button>
            </>
          ) : (
            ""
          )
        }
      />
      {showTable()}
    </Card>
  );
};
VoucherCustomers.displayName = "VoucherCustomers";
export default VoucherCustomers;
